import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import store from './store';
import { Provider } from 'react-redux';


const root = document.getElementById('root');
const localeId = root.getAttribute('data-locale');

const UbisoftPlusApp = () => (
  <Provider store={store}>
    <App localeId={localeId} />
  </Provider>
);

if (process.env.NODE_ENV === 'production') {
  ReactDOM.hydrate(<UbisoftPlusApp />, root);
} else {
  ReactDOM.render(<UbisoftPlusApp />, root);
}
